import { CloudOff, TriangleAlert } from "lucide-react";
import { useState } from "react";

import { useOfflineOutbox } from "../lib/use-offline-outbox";

/**
 * Il cartello della coda.
 *
 * Non compare mai quando non c'e niente da dire. Compare in due modi diversi, perche sono
 * due fatti diversi: qualcosa aspetta la rete, e va bene cosi; oppure qualcosa non e
 * riuscito ad andare per un motivo che non e la rete, e allora serve una mano.
 */
export function OfflineOutboxBanner({
  companyId,
  userId,
  onSynced,
}: {
  companyId: string;
  userId: string;
  onSynced?: () => void;
}) {
  const { inAttesa, segnalate, riprova, elimina } = useOfflineOutbox(companyId, userId, onSynced);
  const [aperto, setAperto] = useState(false);

  if (inAttesa.length === 0 && segnalate.length === 0) return null;

  const problema = segnalate.length > 0;
  const testo = problema
    ? `${segnalate.length} ${segnalate.length === 1 ? "azione non e partita" : "azioni non sono partite"}`
    : `${inAttesa.length} ${inAttesa.length === 1 ? "azione in attesa di invio" : "azioni in attesa di invio"}`;

  return (
    <div
      className={`outbox-banner${problema ? " outbox-banner--allarme" : ""}`}
      role={problema ? "alert" : "status"}
      aria-live="polite"
    >
      <div className="outbox-banner__riga">
        {problema ? <TriangleAlert size={18} aria-hidden="true" /> : <CloudOff size={18} aria-hidden="true" />}
        <p>{testo}</p>
        {problema && (
          <button
            className="outbox-banner__action"
            type="button"
            onClick={() => setAperto((stato) => !stato)}
            aria-expanded={aperto}
          >
            {aperto ? "Chiudi" : "Vedi"}
          </button>
        )}
      </div>

      {problema && aperto && (
        <ul className="outbox-banner__elenco">
          {segnalate.map((operazione) => (
            <li key={operazione.id}>
              <strong>{operazione.label}</strong>
              <span>{operazione.lastError ?? "Invio non riuscito."}</span>
              <span className="outbox-banner__tentativi">Tentativi: {operazione.attempts}</span>
              <div className="outbox-banner__azioni">
                <button type="button" className="button button--outline" onClick={() => void riprova(operazione.id)}>
                  Riprova
                </button>
                <button type="button" className="button button--outline" onClick={() => void elimina(operazione.id)}>
                  Elimina
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
